import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import "./CarruselContacto.css";

export default function CarruselContacto() {
  const { t } = useTranslation();
  const titleRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!titleRef.current) return;
      const rect = titleRef.current.getBoundingClientRect();
      if (rect.top < window.innerHeight - 100) {
        titleRef.current.classList.add("visible");
      } else {
        titleRef.current.classList.remove("visible");
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="carrusel-contacto-container">
      <img
        src="/mano.webp"
        alt={t("carrusel_contacto.alt_img") || "Contacto"}
        className="carrusel-contacto-img"
      />
      <div className="carrusel-contacto-overlay">
        <h1
          ref={titleRef}
          className="carrusel-contacto-title"
          style={{ whiteSpace: "pre-line" } as React.CSSProperties}
        >
          {t("carrusel_contacto.titulo")}
        </h1>
      </div>
    </div>
  );
}
